import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Thumbnail, Col, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import Slider from 'react-slick'
import { fetchProducts, fetchSearchInput, setLoadingSearchPage, changeSearchLabel } from '../actions'

import ProductItem from './product_item'
import CategoryItem from './category_item'
import MetaTags from 'react-meta-tags'

function PrevArrow(props) {
    const { className, style, onClick } = props
    return (
        <image className={className} onClick={onClick} style={{ width: 35, height: 35 }} src='../../static/images/carouselArrow/backward.png' />
    )
}
function NextArrow(props) {
    const { className, style, onClick } = props
    return (
        <image className={className} onClick={onClick} style={{ width: 35, height: 35 }} src='../../static/images/carouselArrow/forward.png' />
    )
}

class SearchPage extends Component {

    state = {
        showProducts: {},
        loadMore: false,
    }

    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll.bind(this));
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.products != this.props.products && nextProps.products != 'unique_products') {
            this.props.setLoadingSearchPage(false)
            this.pushProducts(nextProps.products.products)
        }
        if (nextProps.search_label != this.props.search_label && !_.isEmpty(this.state.showProducts)) {
            this.setState({ showProducts: {} })
        }
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll.bind(this));
    }

    handleScroll() {
        const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
        const body = document.body;
        const html = document.documentElement;
        const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        const windowBottom = windowHeight + window.pageYOffset;
        if (windowBottom >= docHeight && !this.state.loadMore && !_.isEmpty(this.props.products.products)) {
            this.loadMore(this.props.search_label, this.props.products.page + 1)
        }
    }

    pushProducts(newProducts) {
        let showProducts = { ...this.state.showProducts, ...newProducts }
        this.setState({ showProducts: showProducts, loadMore: false })
    }

    loadMore(keyword, page) {
        this.setState({ loadMore: true })
        this.props.fetchProducts(keyword, page, this.pushProducts.bind(this))
    }

    onClick(categoryname) {
        this.props.fetchSearchInput(categoryname)
        this.props.fetchProducts(categoryname)
        this.props.history.push(`/search/${categoryname}`)
        this.setState({ showProducts: {} })
    }

    renderProducts() {
        let id = 0
        return _.map(this.state.showProducts, product => {
            if (product.visible) {
                if ((id + 1) % 4 == 0) {
                    return (
                        <div key={id++}>
                            <ProductItem history={this.props.history} product={product} />
                            <div style={{ padding: 5, visibility: 'hidden' }}>line</div>
                        </div>
                    )
                } else
                    return (
                        <ProductItem history={this.props.history} key={id++} product={product} />
                    )
            }
        })
    }

    renderSubcategory() {
        var setting = {
            responsive: [
                {
                    breakpoint: 767, settings: {
                        dots: false,
                        infinite: false,
                        speed: 500,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        autoplay: false,
                        autoplaySpeed: 5000,
                        swipeToSlide: true,
                        prevArrow: <PrevArrow />,
                        nextArrow: <NextArrow />,
                    }
                },
                {
                    breakpoint: 991, settings: {
                        dots: false,
                        infinite: false,
                        speed: 500,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        autoplay: false,
                        autoplaySpeed: 5000,
                        swipeToSlide: true,
                        prevArrow: <PrevArrow />,
                        nextArrow: <NextArrow />,
                    }
                },
                {
                    breakpoint: 2599, settings: {
                        dots: false,
                        infinite: false,
                        speed: 500,
                        slidesToShow: 6,
                        slidesToScroll: 1,
                        autoplay: false,
                        autoplaySpeed: 5000,
                        swipeToSlide: true,
                        prevArrow: <PrevArrow />,
                        nextArrow: <NextArrow />,
                    }
                }
            ]
        };

        let listSiteShow = [];
        let id = 1

        if (!_.isEmpty(this.props.products)) {
            if (this.props.products.categories) {
                if (this.props.id != 'categories') {
                    _.map(this.props.products.categories, category => {
                        let isSubCategory = category.sub_categories ? true : false
                        if (!isSubCategory) {
                            listSiteShow.push(<div key={id++} style={{ position: 'relative', textAlign: 'center', color: 'white' }} onClick={() => { this.onClick(category.name_th) }}><CategoryItem history={this.props.history} subcat={category} /><div className="centered" style={{ width: '80%', cursor: 'pointer' }}><strong>{category.name_th}</strong></div></div>)
                        } else {
                            _.map(category.sub_categories, sub_category => {
                                listSiteShow.push(<div key={id++} style={{ position: 'relative', textAlign: 'center', color: 'white' }} onClick={() => { this.onClick(sub_category.name_th) }}><CategoryItem history={this.props.history} subcat={sub_category} /><div className="centered" style={{ width: '80%', cursor: 'pointer' }}><strong>{sub_category.name_th}</strong></div></div>)
                            })
                        }
                    })
                    return (
                        <div>
                            <Slider {...setting}>
                                {listSiteShow}
                            </Slider>
                        </div>
                    )
                } else {
                    _.map(this.props.products.categories, category => {
                        listSiteShow.push(<div key={id++} style={{ position: 'relative', textAlign: 'center', color: 'white' }} onClick={() => { this.onClick(category.name_th) }}><CategoryItem history={this.props.history} subcat={category} /><div className="centered" style={{ width: '80%', cursor: 'pointer' }}><strong>{category.name_th}</strong></div></div>)
                    })
                    return (
                        <div>
                            <Slider {...setting}>
                                {listSiteShow}
                            </Slider>
                        </div>
                    )
                }
            } else {
                return (
                    <div></div>
                )
            }
        }
    }

    render() {
        const isCategory = this.props.products.sub_categories || this.props.products.categories ? true : false
        // this.props.loading_search_page == false ? console.log('metatag') : ''
        return (
            <div >
                <div className="container main-bg">
                    {this.props.loading_search_page == false
                        ? <MetaTags>
                            <title>{'ส่งสด - บริการส่งของสดจากตลาด'}</title>
                            <meta property="og:title" content={'ส่งสด บริการส่งของสด'} />
                            <meta property="og:url" content={window.location.href} />
                            <meta property="og:image" content={'imgsrc'} />
                            <meta property="og:description" content={'บริการส่งของสดจาก ตลาดยิ่งเจริญ ที่คัดสรรคุณภาพของวัตถุดิบโดยผู้ซื้อสินค้าส่วนตัว'} />
                            <meta property="og:type" content='website' />
                            <meta property="fb:pages" content="129193147647837" />
                        </MetaTags> : ''
                    }
                    <div className='container'>
                        {/* <h4 className="header-homepage-product"><span className="fa fa-search" aria-hidden="true"></span> ผลลัพธ์ของ {this.props.search_label}</h4> */}
                        <div className="search-result">
                            <h4 style={{ display: 'inline-block' }}>
                                <span className="fa fa-search" aria-hidden="true"></span> ผลลัพธ์การค้นหาคำว่า&nbsp;
                            </h4>
                            <h3 className="header-result-text" style={{ display: 'inline-block' }}><strong>"{this.props.search_label}"</strong>
                            </h3>
                        </div>

                        {this.props.products == 'not_found' && !this.props.loading_search_page ? <div style={{ height: 200, display: 'flex', justifyContent: 'center', alignItems: 'center' }}><h3 style={{ textAlign: 'center', verticalAlign: 'middle' }}>ไม่พบผลลัพธ์การค้นหา</h3></div> : ''}
                        {this.props.loading_search_page ? <div className="loader"></div> : ''}

                        <div style={{ backgroundColor: '#233268' }}>
                            {isCategory && this.props.products != 'not_found' && this.props.products != '' && !_.isEmpty(this.props.products) && !this.props.loading_search_page ?
                                <div><h4 style={{ textAlign: 'center', padding: 15, color: 'white', margin: 0 }}>ประเภทสินค้า</h4><Row className="row-categories" style={{ paddingLeft: 20, paddingTop: 10, paddingBottom: 10, paddingRight: 20 }}>{this.renderSubcategory()}</Row></div> : ''}
                        </div>

                        {!this.props.loading_search_page && this.props.products != 'not_found' ?
                            <div><h4 className="header-homepage-product" style={{ padding: 15, marginTop: 10, marginBottom: 10 }}>สินค้า</h4>
                                <Row>
                                    {this.props.products != 'not_found' ? this.renderProducts() : ''}
                                </Row></div> : ''
                        }

                        {
                            !_.isEmpty(this.props.products.products) && !this.props.loading_search_page
                                ? this.state.loadMore ? <div className='loader'></div>
                                    : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 10 }}>
                                        <button onClick={() => { this.loadMore(this.props.search_label, this.props.products.page + 1) }} className='btn btn-success'>แสดงสินค้าเพิ่มเติม</button>
                                    </div>
                                : ''
                        }
                    </div>
                </div>
            </div >
        )
    }

}

function mapStateToProps(state) {
    return {
        products: state.products,
        search_label: state.search_label_reducer,
        loading_search_page: state.loading_search_page_reducer
    }
}

export default connect(mapStateToProps, { fetchProducts, fetchSearchInput, setLoadingSearchPage, changeSearchLabel })(SearchPage)


// WEBPACK FOOTER //
// ./src/components/search_page.js